var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",class:[_vm.skew === 'right' ? 'skew-right' : '', _vm.skew === 'left' ? 'skew-left' : ''],attrs:{"id":_vm.id}},[_c('div',{staticClass:"section-content px-3 md:px-5"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }